<div>
    <mat-form-field appearance="fill">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" [placeholder]="placeholder" [(ngModel)]="searchText" (keyup)="onSearchTextChange()">
        <mat-hint>{{hint}}</mat-hint>
        <mat-icon *ngIf="searchText && searchText!=''" style="cursor: pointer" matSuffix (click)="clearSearchText()">close</mat-icon>
    </mat-form-field>
</div>

